<section>
  <h2 class="h4">Merge People</h2>
  <div class="card">
    <div class="card-body">
      <p class="card-title">Tap the Merge Selected People button to compare the people selected and choose which information to keep. (Note: Only up to three can be merged at once.)</p>
      <p-table [value]="selectedPeopleToMerge" [columns]="mergePeopleColumns" dataKey="PersonID" [autoLayout]="true" responsiveLayout="scroll" (sortFunction)="customSort($event)" [customSort]="true" [rows]="defaultTableRows" [paginator]="true" [alwaysShowPaginator]="false">
        <ng-template pTemplate="caption">
          <div class="fw-bold text-center p-2">Merge People Selection</div>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" scope="col" [pSortableColumn]="col.field">
              {{col.header}}
              <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
            <th style="width: 4em" scope="col"><span class="visually-hidden">Delete person row</span></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr>
            <td>
              <ng-container *ngFor="let fbiNum of rowData.ENESS_XREF_PeopleFBIFileNumbers">{{fbiNum.FBIFileNumber}}<br /></ng-container>
            </td>
            <td>
              <ng-container *ngFor="let stateNum of rowData.ENESS_XREF_PeopleStateIDNumbers">
                 {{stateNum.StateAbbreviation?.concat(':') || stateNum.ENESS_REF_State?.StateAbbreviation.concat(':')}} {{stateNum.StateIDNumbers}}<br />
             </ng-container>
            </td>
            <td>
              <button type="button" class="btn btn-sm btn-link" aria-label="{{'Person '+ rowData.LastName +' details'}}" tabindex="0" (click)="viewPersonDetails(rowData.PersonID)">{{ rowData.LastName }}</button>
            </td>
            <td>{{ rowData.FirstName }}</td>
            <td>{{ rowData.DateOfBirth | date:"MM/dd/yyyy"}}</td>
            <td>{{ rowData.SSN | ssnFormat}}</td>
            <td class="text-center">
              <button aria-label="Remove person from merge list" pButton type="button" icon="pi pi-times" class="p-button-danger" (click)="removeFromMergeList(rowData.PersonID)" title="Remove person from merge list"></button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length + 1">
              No people selected.
            </td>
          </tr>
        </ng-template>
      </p-table>
      <button type="button" class="btn btn-sm btn-active my-3" (click)="mergePeople()" [disabled]="disableMergeButton">Merge Selected People</button>
    </div>
  </div>
</section>
<aside>
  <p-sidebar (onHide)="onViewPersonDetailsClose()" [(visible)]="displaySidebar" position="right" styleClass="p-sidebar-lg" [showCloseIcon]="false">
    <ng-container *ngIf="showPersonDetails">
      <ng-container *ngIf="personDTO$ | async as person">
        <ness-person-detail [personDTO]="person" [isEventPersonForm]="false" [suppressEdit]="true" (showPersonAddressDetail)="viewAddressDetails($event)"></ness-person-detail>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="showPersonAddressDetails">
      <ng-container *ngIf="personAddress">
        <ness-location-detail *ngIf="showLocationView" [addressDTO]="personAddress" [hasDeletePermission]="false" [hasEditPermission]="hasPermissionToEditAddress" [personAddressType]="personAddressType" [isFromPersonDetails]="true" (editLocationLocationClicked)="editLocation($event)"></ness-location-detail>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="showPersonAddressDetailForm">
      <ng-container *ngIf="personAddress">
        <ness-location-form *ngIf="showEditLocationView" [titleText]="'Edit location'" [isEventLocationForm]="false" [isEditForm]="true" [locationFormData]="personAddress" (associateLocation)="onLocationFormClose($event)"></ness-location-form>
      </ng-container>
    </ng-container>
    <button type="button" (click)="onClickCloseButton()" class="btn btn-active m-3">Close</button>
  </p-sidebar>
</aside>
